module.exports = __webpack_public_path__ + "img/icon12.08678d28.png";